import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { License } from 'src/models/license.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LicenseService } from 'src/app/_services/license.service';

@Component({
  selector: 'company-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css'],
})
export class CompanyLicenseComponent implements OnInit {
  @Input() license: License;
  licenseForm: FormGroup;

  constructor(
    public toastrService: ToastrService,
    private translateService: TranslateService,
    public formBuilder: FormBuilder,
    public licenseService: LicenseService,
  ) {}

  ngOnInit() {
    this.licenseForm = this.formBuilder.group({
      id: [this.license.id || 0],
      companyId: [this.license.companyId || 0],
      license: [this.license.license || '', Validators.required],
      licenseQty: [this.license.licenseQty || 0, Validators.required],
      beginningDate: [ new Date(this.license.beginningDate) || '', Validators.required],
      endingDate: [ new Date(this.license.endingDate) || '', Validators.required],
      comercialName: [this.license.comercialName || '', Validators.required],
      comercialEmail: [this.license.comercialEmail || '', Validators.required],
      code: [this.license.code || ''],
    });
  }

  onSubmit() {
    if (this.licenseForm.valid) {
      const licenseToSend: License = {
        ...this.licenseForm.value
      };
      this.licenseService.save(licenseToSend).subscribe(res => {
        this.toastrService.successReport(this.translateService.instant('alert.successEdit'))
      },
      error => {
        this.toastrService.error(this.translateService.instant('alert.error'))
      })
    } else {
    }
  }
}
